import { RocketIllustration } from '../../../../assets/Ilustrations/RocketIllustration';
import Container from '../../../../core/components/atoms/Container';
import InnerHTMLContainer from '../../../../core/components/molecules/InnerHTMLContainer';

interface ContentZeroProps {
  contentZero: string;
}

function ContentZero({ contentZero }: ContentZeroProps) {
  return (
    <Container direction='col' gap='xxl'>
      <header className='flex items-center justify-center'>
        <RocketIllustration width={240} />
      </header>
      <main>
        <InnerHTMLContainer
          data={contentZero}
          type='textContent'
          className='!break-normal text-mono-color-darkest'
        />
      </main>
    </Container>
  );
}

export { ContentZero };
